import React from "react";
import { useRecoilValue } from "recoil";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { PERMISSIONS } from "../../../PermissionsConstants";
import CameraType2Table from "./view/CameraType2Table";

interface CameraType2Props {}
export const CameraType2: React.FC<CameraType2Props> = () => {
  const viewPermission =
    PERMISSIONS.permission_utilities_securityconfiguration_cameratype2_view;
  const userPermissions = useRecoilValue(permissionsSelector);
  return (
    <> {userPermissions.includes(viewPermission) && <CameraType2Table />} </>
  );
};
export default CameraType2;
